/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Filter, StSvg, TableSearch } from "../../common/svg/AllSvg";
import { url } from "../../../shared/utils/url";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../shared/hooks/use-axios";
import NoSearch from "../../common/form/NoSearch";
import EmptyList from "../../common/form/EmptyList";
import Error from "../../common/form/Error";
import ShopFilter from "./ShopFilter";
import { sitemap } from "../../../shared/utils/sitemap";

const ShopList = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [category, setCategory] = useState<any[]>([])
    const [shopsData, setShopsData] = useState<any[]>([])
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const [filterOpen, setFilterOpen] = useState<boolean>(false)
    const [selectCategory, setSelectCategory] = useState<any[]>([])
    const [selectStation, setSelectStation] = useState<any[]>([])
    const [sts, setSts] = useState<any[]>([])
    const [animation, setAnimation] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [loading1, setLoading1] = useState<boolean>(true)
    const [loading2, setLoading2] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [searchFocus, setSearchFocus] = useState<boolean>(false)
    const [noStore, setNoStore] = useState<boolean>(true)
    const loaderData: any[] = [1, 2, 3, 4, 5]
    const { t } = useTranslation('common');
    const params = useParams();
    const navigate = useNavigate();

    const getCategory = async () => {
        try {
            setLoading1(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.store_category}`);

            if (res && res.status === 200 && res?.data?.length > 0) {
                setCategory(res?.data)
                setLoading1(false)
            }
        } catch (error) {
            setLoading1(false)
            console.error("error while fetching category", error);
        }
    }

    const getStations = async () => {
        try {
            setLoading2(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.searchStation}all/`);
            if (res && res?.status === 200 && res?.data?.length > 0) {
                const arr: any[] = Array.isArray(res?.data) && res?.data?.map((item: any) => ({ label: item?.name, value: item?.code, id: item?.id }));
                setSts(arr)
                setLoading2(false)
            }

        } catch (error) {
            setLoading2(false)
            console.error("error while feching stations", error);
        }
    }

    useEffect(() => {
        !!lang && getCategory();
        !!lang && getStations();
    }, [lang])

    const getStores = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.stores}?${selectCategory?.length > 0 ? `category=${selectCategory?.toString()}` : ""}${selectStation?.length > 0 ? `&station_code=${selectStation?.toString()}` : ""}${!!debouncedValue ? `&search=${debouncedValue}` : ""}`);

            if (res && res.status === 200) {
                setShopsData(res?.data)
                setLoading(false)
                noStore && sitemap()
                setNoStore(false)
            }
        } catch (error: any) {
            if (error?.response?.status === 404) {
                (!!params?.lang ? navigate(`/${params?.lang}/404`) : navigate("/404"))
            }
            setIsError(true)
            setLoading(false)
            console.error("error while fetching stores", error);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        (!!lang && selectCategory?.length > 0) && getStores();
    }, [lang, debouncedValue, selectCategory, selectStation])


    useEffect(() => {
        if (window.innerWidth <= 640 && filterOpen) {
            document.body.style.overflow = "hidden";
        } else {
            setFilterOpen(false)
            document.body.style.overflow = "auto";
        }
    }, [window.innerWidth, filterOpen])

    useEffect(() => {
        if (animation) {
            setTimeout(() => {
                setAnimation(false)
            }, 500)
        }
    }, [animation])

    useEffect(() => {
        setSelectCategory([params?.category])
    }, [params?.category])

    return (
        <>
            {/* Backdrop */}
            <div>
                <span
                    className={`fixed top-0 left-0 z-20 ${filterOpen ? "block" : "hidden"
                        } h-screen w-full bg-[rgba(216,216,216,0.60)] sm:hidden backdrop-blur-[15px]`}
                    onClick={() => setFilterOpen(!filterOpen)}
                ></span>
            </div>

            <div className=" flex items-center justify-center px-[18px] xlsm:px-[25px] xlx:px-[45px] w-full">
                <div className="h-full py-[33px] grid grid-cols-1 w-[1200px] xlx:w-[1384px]">
                    <div className="w-full flex">
                        <div className="w-[250px] xlx:w-[355px] border-r border-primary border-opacity-[0.2] h-full sm:flex hidden">
                            {/* filter */}
                            <ShopFilter category={category} selectCategory={selectCategory} setSelectCategory={setSelectCategory} selectStation={selectStation} setSelectStation={setSelectStation} mobile={false} loading1={loading1} loading2={loading2} sts={sts} />
                        </div>

                        <div className="pb-[15px] pt-[5px] xlx:pt-[15px] xlx:pb-[30px] w-full sm:w-[calc(100%-250px)] xlx:w-[calc(100%-355px)] sm:pl-[25px] flex flex-col gap-[20px] xlx:gap-[25px]">
                            <div className="flex md:items-center justify-between w-full md:flex-row flex-col gap-[13px]">
                                <div className="flex items-center justify-between w-full">
                                    <h3 className="text-primaryText dark:text-white font-bold text-[1.8rem]">{(shopsData?.length > 0 && (selectCategory?.length > 1 || selectStation?.length > 0 || !!search)) ? `${lang === "en" ? `Showing Result for ${shopsData?.length} Filter` : lang === "hi" ? `${shopsData?.length} फ़िल्टर के लिए परिणाम दिखाया जा रहा है` : `${shopsData?.length} फिल्टरसाठी परिणाम दर्शवित आहे`}` : `${t("passenger.stores.shop_from_metro")}`}</h3>

                                    <button className="bg-white dark:bg-bgDarkDull shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] min-w-[40px] h-[40px] rounded-[8px] flex items-center justify-center sm:hidden focus:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] hover:bg-white focus:bg-white border border-transparent focus:border-[#D7D8DD] hover:border-[#D7D8DD] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => setFilterOpen(true)}>
                                        <Filter className="xlx:w-auto xlx:h-auto w-[17px] h-[17px] fill-[#1C1B1F] dark:fill-white" />
                                    </button>
                                </div>

                                <div className="flex items-center gap-[10px] md:w-auto w-full justify-end">
                                    <div className={`border dark:border-[rgb(134,134,134,0.3)] border-[rgba(134,134,134,0.15)] h-[40px] xlx:h-[45px] px-[12px] xlx:px-[15px] flex items-center gap-[8px] xlx:gap-[12px] rounded-[12px] w-full xs:w-[315px] ${searchFocus && "shadow-lg"} hover:shadow-lgdark:hover:border-[#ffffff5e]`}>
                                        <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-blackDull dark:fill-white opacity-[0.7]" />

                                        <input type="text" className="text-opacity-[0.7] text-blackDull font-medium placeholder:text-blackDull placeholder:text-opacity-[0.7] text-sm leading-snug w-full bg-transparent dark:text-textBlackDull placeholder:dark:text-textBlackDull" placeholder={t("passenger.stores.shop_search")} autoComplete="off" value={search} onChange={(e: any) => setSearch(e.target.value)} onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)} />
                                    </div>
                                </div>
                            </div>

                            {loading ?
                                <div className="grid grid-cols-1 mmm:grid-cols-2 lgl:grid-cols-3 gap-[20px]">
                                    {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                        <div className="w-full animate-pulse" key={index}>
                                            <div className="rounded-[20px] h-[220px] xlx:h-[250px] w-full bg-gray-200 dark:bg-gray-700"></div>

                                            <div className='flex flex-col gap-[4px] py-[15px]'>
                                                <div className="w-[40%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                <div className="w-[80%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                <div className="w-[60%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                :
                                <>
                                    {isError ? <Error /> : <>
                                        {shopsData?.length > 0 && <> <div className="grid grid-cols-1 mmm:grid-cols-2 lgl:grid-cols-3 gap-[20px]">
                                            {Array.isArray(shopsData) && shopsData?.map((item: any, index: number) => (
                                                <div className="w-full" key={index}>
                                                    <button className="img-zoom overflow-hidden rounded-[20px] w-full relative" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/store-products/${item?.store_code}`) : navigate(`/store-products/${item?.store_code}`)}>
                                                        <img src={item?.image?.file} alt={item?.store_name} className="rounded-[20px] h-[220px] xlx:h-[250px] w-full" />

                                                        <div className="absolute top-0 left-0 bottom-0 right-0 p-[16px] flex items-start justify-start">
                                                            <div className={`border border-[#C8C8C8] dark:border-[#454545] bg-opacity-[0.8] flex items-center justify-center px-[11px] h-[22px] rounded-[10px] text-white text-xs font-bold uppercase whitespace-nowrap ${item?.status === "open" ? "bg-[#10B85D]" : "bg-[#B81013]"}`}> {item?.status !== "open" ? `${lang === "en" ? "Closed" : lang === "hi" ? "बंद" : "बंद"}` : `${lang === "en" ? "Open" : lang === "hi" ? "खुला" : "उघडा"}`}</div>
                                                        </div>
                                                    </button>

                                                    <div className='flex flex-col gap-[4px] pt-[10px] pb-[15px]'>
                                                        <h4 className='text-primaryText dark:text-white font-semibold'>{item?.store_name}</h4>
                                                        <h6 className='text-blackDark dark:text-textBlackDark font-medium'>{item?.description}</h6>
                                                        <div className='flex gap-[8px]'>
                                                            <StSvg />
                                                            <h6 className='text-blackDull dark:text-textBlackDull font-medium'>{item?.station?.name}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div></>}

                                        {((selectCategory?.length === 0 && selectStation?.length === 0 && !!!search) && shopsData?.length === 0) &&
                                            <EmptyList />
                                        }

                                        {((selectCategory?.length > 0 || selectStation?.length > 0 || !!search) && shopsData?.length === 0) &&
                                            <NoSearch onClick={() => { setSelectCategory([]); setSelectStation([]); setSearch(""); }} />
                                        }
                                    </>}
                                </>}
                        </div>
                    </div>
                </div>
            </div>

            <div className={`fixed left-0 right-0 bottom-0 z-50 ${!filterOpen ? "translate-y-full" : ""} h-[500px] w-full bg-white transition duration-400 sm:hidden focus:!outline-none rounded-t-[30px]`}>
                {/* filter */}
                <ShopFilter category={category} selectCategory={selectCategory} setSelectCategory={setSelectCategory} selectStation={selectStation} setSelectStation={setSelectStation} mobile={true} loading1={loading1} loading2={loading2} sts={sts} />
            </div>
        </>
    );
}

export default ShopList;